import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    SecurityContext,
    ViewEncapsulation
} from '@angular/core';
import { StoryblokService } from '@seven1/angular-storyblok/api';
import { DomSanitizer } from '@angular/platform-browser';
import { IQuoteBlok } from './quote.model';

@Component({
    selector: 'blockquote[s1-quote]',
    imports: [],
    templateUrl: './quote.component.html',
    styleUrl: './quote.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'break-words my-4 text-base lg:text-lg'
    }
})
export class QuoteComponent {
    private _storyblok = inject(StoryblokService);
    private _sanitizer = inject(DomSanitizer);
    block = input.required<IQuoteBlok>();
    renderedContent = computed<string | undefined | null>(() => {
        const content = this.block()?.textContent;
        if (content) {
            const renderedText = this._storyblok.richTextResolver.render(content);
            return renderedText
                ? this._sanitizer.sanitize(
                    SecurityContext.HTML,
                    Array.isArray(renderedText)
                        ? renderedText.join('')
                        : renderedText
                )
                : undefined;
        }
        return undefined;
    });


}
